import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/api";
import { MobileNav } from "@/components/MobileNav";
import { SponsorStrip } from "@/components/SponsorStrip";
import { MediaPartnerStrip } from "@/components/MediaPartnerStrip";
import { MenuComunicati } from "@/components/MenuComunicati";
import { toast } from "sonner";

const OUTLET_LOGOS = {
  perugiatoday: "/logos/perugiatoday.png",
  ternitoday: "/logos/ternitoday.png",
};

export default function RassegnaStampa() {
  const [press, setPress] = useState(null);

  useEffect(() => {
    api
      .get("/press")
      .then((res) => setPress(res.data))
      .catch(() => toast.error("Impossibile caricare la rassegna stampa"));
  }, []);

  return (
    <div className="bg-[#e3edf6] text-[#0f172a] min-h-screen">
      <nav className="border-b border-[#e2e8f0] px-6 md:px-8 py-5 sticky top-0 bg-[#e3edf6]/90 backdrop-blur-md z-50">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
            <img src="/logo-coppa.png" alt="Coppa dei Club" className="h-8 w-auto" />
            <span className="text-[#0284c7] font-mono-x text-xs">/ Hub</span>
          </Link>
          <div className="flex items-center gap-2 text-xs font-ui text-[#475569]">
            <a href="/#calendari" data-testid="nav-calendari" className="hidden sm:inline-block px-4 py-2 bg-white text-[#0f172a] hover:bg-[#38bdf8] transition-all rounded font-semibold border border-[#cbd5e1]">
              Calendari Gare
            </a>
            <Link to="/circoli" data-testid="nav-circoli" className="hidden sm:inline-block px-4 py-2 bg-white text-[#0f172a] hover:bg-[#38bdf8] transition-all rounded font-semibold border border-[#cbd5e1]">
              Circoli
            </Link>
            <Link to="/galleria" data-testid="nav-galleria" className="hidden sm:inline-block px-4 py-2 bg-white text-[#0f172a] hover:bg-[#38bdf8] transition-all rounded font-semibold border border-[#cbd5e1]">
              Galleria foto
            </Link>
            <MenuComunicati prefix={"/"} />
            <Link
              to="/admin"
              data-testid="nav-admin-login"
              className="hidden sm:inline-block px-4 py-2 bg-[#e2e8f0] text-[#0f172a] hover:bg-[#38bdf8] hover:text-[#0f172a] transition-all rounded font-semibold border border-[#cbd5e1]"
            >
              Login Admin
            </Link>
            <MobileNav />
          </div>
        </div>
      </nav>

      <SponsorStrip />

      <MediaPartnerStrip />

      <header className="py-16 md:py-20 px-6 md:px-8 border-b border-[#e2e8f0]">
        <div className="max-w-6xl mx-auto">
          <span className="font-mono-x text-xs text-[#0284c7] tracking-widest uppercase block mb-2">
            Coppa dei Club 2026-27
          </span>
          <h1 className="font-display text-4xl md:text-5xl text-[#0f172a] mb-4">Rassegna stampa</h1>
          <p className="text-base text-[#475569] max-w-2xl leading-relaxed">
            {press
              ? `${press.length} articoli pubblicati sul campionato dai media partner.`
              : "Caricamento della rassegna stampa..."}
          </p>
        </div>
      </header>

      <main className="py-14 px-6 md:px-8">
        <div className="max-w-6xl mx-auto">
          {press && press.length === 0 && (
            <p className="text-sm text-[#475569] font-ui" data-testid="press-empty">
              Nessun articolo pubblicato.
            </p>
          )}
          <div className="space-y-3" data-testid="press-archive-list">
            {(press || []).map((a) => {
              const logo = OUTLET_LOGOS[a.outlet.toLowerCase()];
              return (
                <a
                  key={a.id}
                  href={a.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`press-article-${a.id}`}
                  className="bg-white border border-[#e2e8f0] rounded-xl p-5 flex items-center gap-4 hover:border-[#38bdf8]/50 hover:shadow-sm transition-all"
                >
                  {logo ? (
                    <img src={logo} alt={a.outlet} className="h-5 w-auto object-contain shrink-0 max-w-[120px]" />
                  ) : (
                    <span className="text-[10px] font-ui font-bold text-[#0284c7] uppercase shrink-0 w-[120px]">
                      {a.outlet}
                    </span>
                  )}
                  <span className="min-w-0 flex-1">
                    <span className="block text-sm font-ui font-semibold text-[#0f172a] leading-snug">{a.title}</span>
                    <span className="block text-[10px] font-ui text-[#64748b] mt-1">
                      {new Date(a.date).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" })}
                    </span>
                  </span>
                  <span className="shrink-0 text-[#0284c7] text-xs font-ui font-semibold">Leggi →</span>
                </a>
              );
            })}
          </div>
        </div>
      </main>

      <footer className="border-t border-[#e2e8f0] py-6 px-8 bg-[#d6e4f0] text-xs font-mono-x text-[#64748b] text-center">
        Coppa dei Club 2026-27 • Portale Ufficiale Calendari, Gironi Gold &amp; Silver • MSP Italia Umbria • Segreteria
        Generale:{" "}
        <a href="tel:3510262959" className="text-[#0284c7] hover:underline">
          3510262959
        </a>{" "}
        • Segreteria Coppa dei Club:{" "}
        <a href="mailto:coppadeiclubmspumbria@gmail.com" className="text-[#0284c7] hover:underline">
          coppadeiclubmspumbria@gmail.com
        </a>
      </footer>
    </div>
  );
}
